import { useState, useEffect } from "react";
import { COOKIE } from "~/const/cookie";
import { G_ViewableRating } from "~/lib/graphql";
import { useAuth } from "~/provider/auth";
import { getCookie } from "~/util/get-cookie";

export const useViewableRatingBlock = () => {
  const { isLoggedIn, viewableRating } = useAuth();
  const isDisableAdultLink = getCookie(COOKIE.ADULT_LINK_DISABLE.KEY) !== undefined;
  const [isAdultLinkAllowed, setIsAdultLinkAllowed] = useState(false);

  useEffect(() => {
    if (isDisableAdultLink) {
      setIsAdultLinkAllowed(false);
      return;
    }
    // 未ログイン状態であれば、アダルトリンクは表示
    if (!isLoggedIn) {
      setIsAdultLinkAllowed(true);
      return;
    }
    // ログイン状態かつレーティングがR_18を許容する場合は表示
    if (isLoggedIn && viewableRating === G_ViewableRating.R18) {
      setIsAdultLinkAllowed(true);
      return;
    }

    setIsAdultLinkAllowed(false);
  }, [isLoggedIn, isDisableAdultLink, viewableRating]);

  return { isAdultLinkAllowed };
};
